import React from 'react'
import PropTypes from 'prop-types'
import CountryFlag from 'react-country-flag'
import { Link } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'

import { translate } from '../../helpers/stringHelpers'

// components
import Badge from '../badge'
import Button from '../button'
import CardBody from '../cardBody'
import FavouriteIndicator from '../favouriteIndicator'

const getLotNumberString = (listingType, isMarketplace = false) => {
  if (isMarketplace) return 'ItemCodes_MARKETPLACE_DISPLAY_VALUE'
  if (listingType === 'listing') return 'ItemCodes_LISTING_DISPLAY_VALUE'
  return 'ItemCodes_LOT_DISPLAY_VALUE'
}

const ListingInfoSingle = ({
  auctionUuid,
  listingUuid,
  onDescriptionLinkClick
}) => {
  const listing = useSelector(state => state.lots.listings[listingUuid], shallowEqual)
  const auctionTitle = useSelector(state => listing?.isMarketplace ? translate('SEOCodes_PAGE_TITLE_MARKETPLACE_PAGE') : state.auctions.auctions[auctionUuid]?.title)
  const isItemLocationVisible = useSelector(state => state.auctions.configurations[auctionUuid]?.showItemLocation)
  const buyersPremiumPercentage = listing?.buyersPremium
  const hammerTaxRate = listing?.hammerTaxRate
  const buyersPremiumTaxRate = listing?.buyersPremiumTaxRate
  const chargesTaxRate = listing?.chargesTaxRate
  if (!auctionTitle || !listing) return null
  return (
    <CardBody className='listing__info'>
      <FavouriteIndicator
        listingUuid={listingUuid}
      />
      <Link to={listing.isMarketplace ? '/marketplace' : `/auctions/${auctionUuid}`}>
        <h2 className='h4 lot__info--auction-title'>
          {auctionTitle}
        </h2>
      </Link>
      <h1 className='h3 lot__info--heading'>
        {listing.lotNumber
          ? (
            <span className='text-muted lot__info--lot-number lot__number'>
              {translate(getLotNumberString(listing.type, listing.isMarketplace))} {listing.isMarketplace ? listing.id : listing.lotNumber}:
            </span>
            )
          : null}
        <span className='lot__info--title'>{listing.title}</span>
      </h1>
      {listing.countryCode && isItemLocationVisible
        ? (
          <div className='pull-right text-muted'>
            <Badge>
              {listing.countryCode}
              <CountryFlag
                aria-label={listing.countryCode}
                countryCode={listing.countryCode.replace('UK', 'GB')}
                className='lot__country-flag'
                svg
                style={{
                  marginLeft: '0.5em',
                  verticalAlign: 'text-top'
                }}
                title={listing.countryCode}
              />
            </Badge>
          </div>
          )
        : null}
      {listing.summary && <div className='text-muted lot__info--summary' dangerouslySetInnerHTML={{ __html: listing.summary }} />}
      {buyersPremiumPercentage && buyersPremiumPercentage > 0
        ? <p id='listing-info__content--buyers-premium-percentage' className='h6'>
          <strong id='listing-info__heading--buyers-premium-percentage'> {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_BUYERS_PREMIUM')}: </strong> {' '}{buyersPremiumPercentage}%
        </p>
        : null}
      {hammerTaxRate && hammerTaxRate > 0
        ? <p id='listing-info__content--hammer-tax-rate' className='h6'>
          <strong id='listing-info__heading--hammer-tax-rate'> {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_HAMMER_TAX_RATE')}: </strong> {' '}{hammerTaxRate}%
        </p>
        : null}
      {buyersPremiumTaxRate && buyersPremiumTaxRate > 0
        ? <p id='listing-info__content--buyers-premium-tax-rate' className='h6'>
          <strong id='listing-info__heading--buyers-premium-tax-rate'> {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_BP_TAX_RATE')}: </strong> {' '}{buyersPremiumTaxRate}%
        </p>
        : null}
      {chargesTaxRate && chargesTaxRate > 0
        ? <p id='listing-info__content--charges-tax-rate' className='h6'>
          <strong id='listing-info__heading--charges-tax-rate'> {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_CHARGES_TAX_RATE')}: </strong> {' '}{chargesTaxRate}%
        </p>
        : null}
      {onDescriptionLinkClick
        ? (
        <Button color='link' className='lot__info--description-link pull-right' size='sm' onClick={onDescriptionLinkClick}>
          {translate('JspPublicCodes_JSP_LISTING_VIEW_DESCRIPTION')}
        </Button>
          )
        : null}
    </CardBody>
  )
}

ListingInfoSingle.propTypes = {
  auctionUuid: PropTypes.string.isRequired,
  listingUuid: PropTypes.string.isRequired,
  onDescriptionLinkClick: PropTypes.func
}

ListingInfoSingle.defaultProps = {
  isItemLocationVisible: true
}

export default React.memo(ListingInfoSingle)
